import { notFound } from "next/navigation"

export const slugArrayToSlug = (slug: string[]): string => {
  if (!slug || !Array.isArray(slug) || slug.length === 0) {
    notFound()
  }
  const cleanSlug = slug
    .filter(s => s && typeof s === "string" && s.trim() !== "")
    .join("/")

  if (cleanSlug.length === 0) {
    notFound()
  }
  return cleanSlug
}
